import React from 'react';
import { NavLink  } from "react-router-dom";

import HeroSection from '../sections/HeroSection/HeroSection';
import BasicSection from '../sections/BasicSection/BasicSection';
import MultiInfoSection from '../sections/MultiInfoSection/MultiInfoSection';
import MoreDescriptionSection from '../sections/MoreDescriptionSection/MoreDescriptionSection';
import AddressAllegroSection from '../sections/AddressAllegroSection/AddressAllegroSection';
import DescriptionSection from '../sections/DescriptionSection/DescriptionSection';
import OneLineSection from '../sections/OneLineSection/OneLineSection';
import Slider from '../sections/Slider/Slider';

const Studio = () => (
    <React.Fragment>
        <HeroSection image="./assets/studio_banner.jpg"/>
        <BasicSection
            title="studio graficzne"
            theme="darkblue"
            leftColumn={
                <div className="light-bulp">
                    <img
                        className="full-image"
                        src="./assets/big_bulp.png"
                        alt=""
                    />
                    <img
                        className="full-image light"
                        src="./assets/big_bulp_light.png"
                        alt=""
                    />
                </div>
            }
            rightColumn={
                <p>
                  Nasz zespół tworzą ludzie doskonale przygotowani do realizowania
                  powierzonych im projektów. To nie tylko profesjonaliści znający
                  się na swoim fachu, to również barwne indywidualności o artystycznych
                  charakterach. Każdy prezentuje oryginalne i niebanalne podejście do
                  kreacji, co skutkuje wyjątkowym i świeżym stylem każdej realizacji.
                  Tworzymy i projektujemy z sercem i pasją, posiłkując się zdobytym
                  doświadczeniem i posiadaną wiedzą, wciąż poszukując nowych pomysłów
                  i rozwiązań. Choć każdy inny, razem potrafimy tchnąć życie w każdy,
                  nawet z pozoru banalny temat, by zaowocował on zadowoleniem Klienta.
                  Nad każdym projektem pochylamy się wspólnie, dopracowujemy go dyskutując
                  i analizując pomysły, tak by wykuć z nich najlepsze możliwe rozwiązanie.
                  W naszej różnorodności tkwi ogromna siła, która sprawia, że nasze
                  projekty stronią od banału i tchną ożywczą świeżością.
                </p>
            }
        />
        <MultiInfoSection
            items={[
                {img: './assets/naklejka_pomysl.png', text: 'pomysł'},
                {img: './assets/naklejka_strategia.png', text: 'strategia'},
                {img: './assets/naklejka_kreacja.png', text: 'kreacja'},
                {img: './assets/naklejka_realizacja.png', text: 'realizacja'}
            ]}
        />
        <OneLineSection
            title="nasze realizacje"
            theme="blue"
            content={
                <p>
                …, ale brakuje Ci pomysłu?
                    Masz produkt, ale nie masz opakowania?
                    Masz opakowanie, ale nie masz etykiety?
                    Masz firmę, ale nie masz logo?
                    W każdej z powyższych sytuacji świetnie trafiłeś!<br/><br/>

                    Podpowiemy, doradzimy, zaprojektujemy, wydrukujemy i zrealizujemy
                    każdy temat.<br/><br/>
                    Lubimy wyzwania – te duże i te malutkie. Zaopiekujemy
                    się Twoim projektem z czułością i dbałością o wszelkie jego i Twoje
                    potrzeby. Dopieścimy detale, nadamy koloru i wyrazu, wydobędziemy
                    jego najistotniejsze cechy i podkreślimy najlepsze strony. Sprawimy,
                    że zaistnieje i będzie lśnił!
                </p>
            }
            />
        <DescriptionSection
            imageButton="./assets/etykiety-link.png"
            imageLink="/poligrafia#wydruk-etykiet"
        >
            <NavLink to="/#contact-form">
                <img className="image-button" alt="" src="./assets/calculate-link.png"/>
            </NavLink>
        </DescriptionSection>
        <Slider
            items={[
                {
                  image: './assets/products/efiore/thumb.jpg',
                  link: '/realizacje/efiore'
                },
                {
                  image: './assets/products/glikol/thumb.jpg',
                  link: '/realizacje/glikol'
                },
                {
                  image: './assets/products/miodowy_ogrod/thumb.jpg',
                  link: '/realizacje/miodowy_ogrod'
                },
                {
                  image: './assets/products/bassau/thumb.jpg',
                  link: '/realizacje/bassau'
                },
                {
                  image: './assets/products/nails/thumb.jpg',
                  link: '/realizacje/nails'
                },
                {
                  image: './assets/products/nirobio/thumb.jpg',
                  link: '/realizacje/nirobio'
                },
              ]}
        />
        <MoreDescriptionSection
            img="./assets/naklejka_karton.png"
            text={
                <div>
                    Istnieje możliwość wydruku próbnego<br/>- dzięki któremu przetestują Państwo jakość druku oraz kleju.<br/>
                    <b>Zamów wydruk próbny: <a href="tel:509-631-155">+48 509 631 155</a>, <a href="mailto:biuro@printlabel.pl">biuro@printlabel.pl</a></b>
                </div>
            }
        />
        <AddressAllegroSection />
    </React.Fragment>
);

export default Studio;